import { render, staticRenderFns } from "./VocabList.vue?vue&type=template&id=50033eae"
import script from "./VocabList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VocabList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports